import * as externalAssignmentAPI from '@adobe/edex/frontend/api/externalAssignment';
import { AxiosRequestConfig } from 'axios';

const externalAssignmentModule = {
  namespaced: true,
  state: {
    assignment: null,
    loading: false,
  },
  mutations: {
    set(state, assignment) {
      state.assignment = assignment;
      state.loading = false;
    },
    setLoading(state, loading = true) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchExternalAssignments({ commit, state }, params: Record<string, any>) {
      commit('setLoading');
      const config: AxiosRequestConfig = {
        params: {
          ...params,
        },
      };
      const { data } = await externalAssignmentAPI.fetchAssignments(config);
      commit('set', data);
    },
  },
};

export default externalAssignmentModule;
